import { Box } from '@mui/material';
import { CircleOutlined } from '@mui/icons-material';

interface IProps {
  onSwitchSelect: () => void;
  isSelected: boolean;
  children: any;
}

export default function SelectableCard({
  onSwitchSelect,
  isSelected,
  children,
}: IProps) {
  return (
    <Box display="flex" flexGrow={1} my={1} onClick={onSwitchSelect}>
      {/* Radio Multiselect */}
      <Box alignItems="center" display="flex" justifyContent="center" mr={1}>
        <CircleOutlined
          stroke={isSelected ? '#519AB9' : '#FFF'}
          style={{
            color: isSelected ? '#519AB9' : '#CCC',
          }}
        />
      </Box>
      {/* Card */}
      <Box
        display="flex"
        flexGrow={1}
        p={2}
        style={{
          borderRadius: '15px',
          border: '1px solid #519AB9',
          backgroundColor: isSelected ? '#DFF1F7' : 'transparent',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
